import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'footerContactHover',
  $names: {
    target: '.contact-footer_contents',
    text: '.contact-footer_copy_txt',
    split: '.split_item',
    splitInner: '.split_inner',
    bg: '.contact-footer_bg',
  },
}

export default class FooterContactHover extends BaseJsHover {
  $bg = null
  clipPercents = []
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  _set$() {
    super._set$()
    this.$bg = this.$contentRoot.querySelector(this.$names.bg)
    const $texts = this.$contentRoot.querySelectorAll(this.$names.text) || []
    $texts.forEach(($text) => {
      const $splits = $text.querySelectorAll(this.$names.split)
      if ($splits && $splits.length > 0) {
        $splits.forEach(($split, i) => {
          this.clipPercents[i] = {
            percent: 0,
          }

          const $splitInner = $split.querySelectorAll(this.$names.splitInner)[1]
          if ($splitInner) {
            gsap.set($splitInner, {
              clipPath: 'inset(0% 0% 100% 0%)',
              opacity: 1,
            })
          }
        })
      }
    })
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      if ($target) {
        const $texts = $target.querySelectorAll(this.$names.text)
        $texts.forEach(($text) => {
          const $splits = $text.querySelectorAll(this.$names.split)
          if ($splits && $splits.length > 0) {
            $splits.forEach(($split, i) => {
              const $splitInner = $split.querySelectorAll(this.$names.splitInner)[1]
              if ($splitInner) {
                // gsap.killTweensOf(this.clipPercents[i])

                gsap.to(this.clipPercents[i], {
                  percent: 1,
                  duration: 0.875,
                  ease: 'cubic.out',
                  delay: i * 0.0175 + 0.0175,
                  onUpdate: () => {
                    if (this.clipPercents[i].percent < 0.5) {
                      const clipPercent = this.clipPercents[i].percent * 2 * 100
                      gsap.set($splitInner, {
                        clipPath: `inset(0% 0% ${100 - clipPercent}% 0%)`,
                      })
                    } else {
                      const clipPercent = (this.clipPercents[i].percent - 0.5) * 2 * 100
                      gsap.set($splitInner, {
                        clipPath: `inset(${clipPercent}% 0% 0% 0%)`,
                      })
                    }
                  },
                })
              }
            })
          }
        })
      }

      gsap.to(this.$bg, {
        y: '100%',
        duration: 0.875,
        ease: 'cubic.out',
      })

      resolve()
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $inner = $target.querySelector(this.$names.inner)
      if ($target) {
        const $texts = $target.querySelectorAll(this.$names.text)

        $texts.forEach(($text) => {
          const $splits = $text.querySelectorAll(this.$names.split)
          if ($splits && $splits.length > 0) {
            $splits.forEach(($split, i) => {
              const $splitInner = $split.querySelectorAll(this.$names.splitInner)[1]
              if ($splitInner) {
                // gsap.killTweensOf(this.clipPercents[i])

                gsap.to(this.clipPercents[i], {
                  percent: 0,
                  duration: 0.875,
                  ease: 'cubic.out',
                  delay: i * 0.0175 + 0.0175,
                  onUpdate: () => {
                    if (this.clipPercents[i].percent < 0.5) {
                      const clipPercent = this.clipPercents[i].percent * 2 * 100
                      gsap.set($splitInner, {
                        clipPath: `inset(0% 0% ${100 - clipPercent}% 0%)`,
                      })
                    } else {
                      const clipPercent = (this.clipPercents[i].percent - 0.5) * 2 * 100
                      gsap.set($splitInner, {
                        clipPath: `inset(${clipPercent}% 0% 0% 0%)`,
                      })
                    }
                  },
                })
              }
            })
          }
        })
      }

      gsap.to(this.$bg, {
        y: '-100%',
        duration: 0.875,
        ease: 'cubic.out',
      })
      resolve()
    })
  }
}